import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddNotificationPayload, AppNotification, NotificationsState } from "./types";

const initialState: NotificationsState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<AddNotificationPayload>) => {
      const newNotification: AppNotification = {
        id: `notification_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`,
        title: action.payload.title,
        message: action.payload.message,
        type: action.payload.type || "info",
        iconName: action.payload.iconName,
        isRead: false,
        timestamp: new Date().toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
        }),
        createdAt: new Date().toISOString(),
      };

      state.notifications.unshift(newNotification);
      state.unreadCount = state.notifications.filter((n) => !n.isRead).length;
    },

    markAsRead: (state, action: PayloadAction<string>) => {
      const index = state.notifications.findIndex((n) => n.id === action.payload);
      if (index !== -1) {
        state.notifications.splice(index, 1);
        state.unreadCount = state.notifications.filter((n) => !n.isRead).length;
      }
    },

    markAllAsRead: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
    },

    removeNotification: (state, action: PayloadAction<string>) => {
      const index = state.notifications.findIndex((n) => n.id === action.payload);
      if (index !== -1) {
        state.notifications.splice(index, 1);
        state.unreadCount = state.notifications.filter((n) => !n.isRead).length;
      }
    },

    clearAllNotifications: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },

    // Action para limpar notificações antigas (opcional)
    cleanOldNotifications: (state) => {
      const oneHourAgo = Date.now() - 60 * 60 * 1000;
      state.notifications = state.notifications.filter(
        (notification) => new Date(notification.createdAt).getTime() > oneHourAgo
      );
      state.unreadCount = state.notifications.filter((n) => !n.isRead).length;
    },
  },
});

export const {
  addNotification,
  markAsRead,
  markAllAsRead,
  removeNotification,
  clearAllNotifications,
  setLoading,
  setError,
  cleanOldNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
